import React from 'react'
import MapComponent from './MapComponent'
import MapComponent2 from './map2'
import {PageTitle} from '../../../_metronic/layout/core'

const Map = () => {
  const updateItemId = (address) => {
    console.log(address)
    // const countryCode =
    //   address.context?.find((contextItem: any) => contextItem.id.startsWith('country.'))
    //     ?.short_code || ''
    // const country =
    //   address.context?.find((contextItem: any) => contextItem.id.startsWith('country.'))?.text || ''
    // const state =
    //   address.context?.find((contextItem: any) => contextItem.id.startsWith('region.'))?.text || ''
    // const city =
    //   address.context?.find((contextItem: any) => contextItem.id.startsWith('place.'))?.text || ''
    // const district =
    //   address.context?.find((contextItem: any) => contextItem.id.startsWith('district.'))?.text ||
    //   ''
    // const locality =
    //   address.context?.find((contextItem: any) => contextItem.id.startsWith('locality.'))?.text ||
    //   ''
    // const postcode =
    //   address.context?.find((contextItem: any) => contextItem.id.startsWith('postcode.'))?.text ||
    //   ''
    // const formattedPostcode = [locality, district, city].filter(Boolean).join(', ')
    // setCountryCode(countryCode)
    // setCountry(country)
    // setError(false)
    // setState(state)
    // setText(address.text)
    // setCity(formattedPostcode)
    // setPincode(postcode)
    // setLatitude(address.center[1])
    // setLongitude(address.center[0])
  }

  return (
    <div className=''>
      <PageTitle breadcrumbs={[]}>Configure Map</PageTitle>
      <MapComponent updateItemId={updateItemId} />
      {/* <MapComponent2 updateItemId={updateItemId} /> */}
    </div>
  )
}

export default Map
